import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/sharp-solid-svg-icons';
import type { ReactNode } from 'react';
import { SCView } from '../view';

function SCLoading({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <SCView flex justifyCenter itemsCenter p={2} className={className} style={style}>
      <FontAwesomeIcon icon={faSpinnerThird} spin />
      Loading...
    </SCView>
  );
}

function SCError({
  message,
  className,
  style,
  children,
}: {
  message: string;
  className?: string;
  style?: React.CSSProperties;
  children?: ReactNode;
}) {
  return (
    <SCView
      flex
      flexCol
      justifyCenter
      itemsCenter
      gap={2}
      p={2}
      className={className}
      style={style}
    >
      <SCView textXl>Something Error</SCView>
      <div>{message}</div>
      <SCView mt={4}>{children}</SCView>
    </SCView>
  );
}

export { SCError, SCLoading };
